// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loginBtn{position:relative;width:100%}.loginMenu{contain:none;margin-top:13px;overflow:visible}.loginMenuContainer{background-color:#fff;border-radius:5px;right:10px;top:50px;width:350px}.loginMenuContainer:before{border-bottom:13px solid #fff;border-left:10px solid transparent;border-right:10px solid transparent;content:\"\";height:13px;position:absolute;right:28px;top:0;transform:translateY(-100%);width:10px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
